export enum TeamMemberFormAccessLevel {
  Organization = 'organization',
  Project = 'project',
}

export enum TeamMemberFormAccessPermissions {
  Admin = 'admin',
  Viewer = 'viewer',
  None = 'none',
}

export enum TeamMemberPermissions {
  Owner = 'owner', // owner of organization
  Admin = 'admin', // admin of organization or project
  Viewer = 'viewer', // viewer of organization or project
}

export enum TeamMemberRoles {
  All = 'all',
  Owner = 'owner',
  Admin = 'admin',
  Editor = 'editor',
  Viewer = 'viewer',
}
